'use client';
'use strict';

require('react');
var createOptionalContext = require('../../core/utils/create-optional-context/create-optional-context.cjs');
require('clsx');
require('@mantine/hooks');
require('../../core/MantineProvider/Mantine.context.cjs');
require('../../core/MantineProvider/default-theme.cjs');
require('../../core/MantineProvider/MantineProvider.cjs');
require('../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.cjs');
require('../../core/Box/Box.cjs');
require('../../core/DirectionProvider/DirectionProvider.cjs');

const [ColorPickerProvider, useColorPickerContext] = createOptionalContext.createOptionalContext(null);

exports.ColorPickerProvider = ColorPickerProvider;
exports.useColorPickerContext = useColorPickerContext;
//# sourceMappingURL=ColorPicker.context.cjs.map
